import { useTranslation } from 'react-i18next';
import { IApplicationPreviewComments } from '../../../types/interface';
import LogTimeline from 'components/timelines/LogTimeline';
import { applicationCommentsToDisplayItems } from 'utils/helpers';
import { applicationFieldMap } from 'utils/staticData';

const resolveFieldLabel = (
  field: string,
  t: (key: string) => string
): string => {
  const translationKey =
    applicationFieldMap[field as keyof typeof applicationFieldMap];
  if (translationKey) {
    return t(translationKey);
  }
  // Fallback: humanize the field name (replace underscores with spaces, capitalise first letter)
  return field.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
};

const ApplicationComments = ({
  comments
}: {
  comments: IApplicationPreviewComments[];
}) => {
  const { t } = useTranslation();

  if (!comments.length) return null;

  const resolvedComments: IApplicationPreviewComments[] = comments.map(c => {
    if (
      c.type === 'FIELD_UPDATED' &&
      Array.isArray(c.change_fields) &&
      c.change_fields.length > 0
    ) {
      const labels = c.change_fields.map(field => resolveFieldLabel(field, t));
      return {
        ...c,
        message: `${t('overview.activity_log.fields_updated')} ${labels.join(
          ', '
        )}`
      };
    }
    return c;
  });

  return (
    <LogTimeline data={applicationCommentsToDisplayItems(resolvedComments)} />
  );
};

export default ApplicationComments;
